import React from 'react';
import AgeInfo from 'components/Formaters/AgeInfo'
import GenderInfo from 'components/Formaters/GenderInfo'
export default ({item}) => (
  <div className="targetinfo">
    <AgeInfo item={item} />
    <GenderInfo item={item} />
  </div>

);



// WEBPACK FOOTER //
// ./src/components/Formaters/Targetinfo.jsx